var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlayGame = function SvgGooglePlayGame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 8334",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-game_svg__a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171e2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3206"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "\\u20B9",
    transform: "translate(19.805 21.048)",
    fill: "#ffc165",
    fontSize: 12,
    fontFamily: "Lexend-Regular, Lexend"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 743",
    fill: "none",
    stroke: "#ffc165",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 25.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3215",
    transform: "translate(3.878 3.878)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 188",
    cx: 22.622,
    cy: 22.622,
    r: 22.622,
    fill: "url(#google-play-game_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-logo-game-controller-b",
    fill: "#ffc968"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26579",
    d: "M16.507 20.019a.981.981 0 1 0 .976.981.978.978 0 0 0-.976-.981Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26580",
    d: "M33.26 22.26c-1.072-4.477-2.205-6.854-4.477-7.527a4.512 4.512 0 0 0-1.3-.2c-1.4 0-2.372.744-4.861.744s-3.465-.744-4.861-.744a4.462 4.462 0 0 0-1.3.2c-2.271.673-3.4 3.055-4.477 7.527s-.875 7.709.389 8.311a1.476 1.476 0 0 0 .632.142c1.1 0 2.281-1.2 3.424-2.63 1.3-1.624 1.624-1.669 5.579-1.669h1.235c3.95 0 4.279.04 5.579 1.669 1.138 1.426 2.327 2.63 3.424 2.63a1.492 1.492 0 0 0 .632-.142c1.257-.607 1.449-3.839.382-8.311Zm-16.748.744a2 2 0 1 1 1.983-2 2 2 0 0 1-1.983 2Zm8.746-.986a1.017 1.017 0 1 1 1.017-1.017 1.017 1.017 0 0 1-1.017 1.016Zm2.221 2.221a1.014 1.014 0 1 1 1.017-1.012 1.016 1.016 0 0 1-1.018 1.011Zm0-4.441a1.017 1.017 0 1 1 1.017-1.017 1.017 1.017 0 0 1-1.018 1.016Zm2.221 2.221a1.017 1.017 0 1 1 1.017-1.017 1.017 1.017 0 0 1-1.018 1.015Z"
  })))));
};
export default SvgGooglePlayGame;